document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-faq-section-wrapper');
  
  sections.forEach(section => {
    const faqItems = section.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
      const button = item.querySelector('.faq-question');
      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');
        
        // Close all other items for a clean accordion effect
        faqItems.forEach(i => i.classList.remove('active'));
        
        // Toggle the clicked one
        if(!isOpen) {
          item.classList.add('active');
        }
      });
    });
  });
});